module.exports = __webpack_public_path__ + "static/media/review-image-johannak.56940ee3.png";